((doc, win) => {
    const timelineHandler = (timelineSelector) => {
        const timelines = doc.querySelectorAll(timelineSelector);

        timelines.forEach((timeline) => {
            const steps = timeline.querySelectorAll(".tl-step");
            const items = timeline.querySelectorAll(".tl-item");

            timeline.addEventListener("click", (e) => {
                const targetStep = e.target.closest(".tl-step");

                if (!targetStep) return;

                steps.forEach((step) => step.classList.remove("is_active"));
                targetStep.classList.add("is_active");

                const targetId = targetStep.dataset.target;

                items.forEach((item) => {
                    item.dataset.id === targetId
                        ? item.classList.add("is_active")
                        : item.classList.remove("is_active");
                });
            });
        });
    };

    doc.addEventListener("DOMContentLoaded", () =>
        timelineHandler(".timeline")
    );
    doc.addEventListener("shopify:section:load", () =>
        timelineHandler(".timeline")
    );
})(document, window);